<template>
  <div class="comment-block">
    <el-card v-for="c in items" :key="c.id" class="box-card">
      <pre class="slim-comment">{{ c.comment }}</pre>
      <!-- {{ c.comment }} -->
      <br />
      <div class="comment-info">
        {{ c.username }} - {{ dateTimeFormat(c.timestamp) }}
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Comments",
  props: {
    items: Array,
  },
  data() {
    return {
      state: {},
    };
  },
  methods: {
    dateTimeFormat: function (date) {
      if (typeof date == "undefined") {
        return "";
      }
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped lang="scss">
.comment-block {
  overflow-y: auto;
  max-height: 800px;
}
.box-card {
  margin: 0.5em;
  text-align: left;
}

.comment-info {
  font-size: 0.8em;
  color: #999;
  font-weight: bold;
  float: right;
}

.slim-comment {
  margin: 0;
  padding: 0;
  font-family: Roboto, sans-serif;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>